import { produce } from "immer";

// Reducer limpio, sin fugas de propiedades de la action al estado
function formReducer(state, action) {
    switch (action.type) {

        // Actualiza un campo del entity
        case "update": {
            let isDirty = true;
            let errors = { ...state.errors };
            let entity;

            if (action.name != null) {
                // Actualizar propiedad específica
                entity = produce(state.entity, draft => {
                    draft[action.name] = action.value;
                });

                // Si ya se había enviado, limpia el error del campo que se actualiza
                if (state.submitted && state.errors != null) {
                    const { [action.name]: removed, ...rest } = state.errors;
                    errors = rest;
                }

            } else {
                // Reemplazar la entidad completa
                entity = action.value;
                isDirty = false;
            }

            return {
                ...state,
                entity,
                isDirty,
                errors
            };
        }

        // Marca el formulario como enviado (para activar validaciones visuales)
        case "submitted":
            return {
                ...state,
                submitted: true
            };

        // Cuando el formulario se guarda correctamente
        case "saved": {
            const savedEntity =
                action.savedEntity != null
                    ? action.savedEntity
                    : state.entity;

            return {
                ...state,
                visible: false,
                isDirty: false,
                entity: savedEntity
            };
        }

case "setErrors":
    return {
        ...state,
        errors: action.errors
    };

case "validate":
    return {
        ...state,
        errors: action.errors
    };


        case "show":
            return {
                ...state,
                visible: true
            };

        case "hide":
            return {
                ...state,
                visible: false
            };

        // *** EL FIX IMPORTANTE ***
        // Reset limpio: aplica únicamente lo que retorna getDefault()
        case "reset": {
            const defaults = action.getDefault();

            return {
                ...state,
                entity: defaults.entity,  // solo la entidad por defecto
                errors: {},
                isDirty: false,
                submitted: false
            };
        }

        default:
            throw new Error("invalid action");
    }
}

export default formReducer;
